import './assets/scss/main.scss';

document.addEventListener('DOMContentLoaded', () => {
    const spoilerElements = document.querySelectorAll('.spoiler');

    spoilerElements.forEach(spoiler => {
        spoiler.addEventListener('click', () => {
            const spoilerContent = spoiler.nextElementSibling;
            spoiler.classList.toggle('active');
            spoilerContent.classList.toggle('show');
        });
    });

    const burger = document.querySelector('.burger');
    const wrapper = document.querySelector('.header_wrapper');

    burger.addEventListener('click', () => {
        burger.classList.toggle('active');
        wrapper.classList.toggle('active');
        document.body.classList.toggle('fixed');
    });
});